module Meevo.Plugins.MeevoTheming {

    export class MeevoThemingSectionBase extends Meevo.Components.CommonClasses.CommonSectionBase {
        protected tenantId: number;
        public get readState() {
            return this.context.isReadonly;
        }

        protected sendCss() {
            console.log('MeevoThemingSectionBase. sendCss is not implemented in subclass.');
        }

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected context: MeevoThemingContext,
            protected saveFunction: any,
            protected cancelFunction: any,
            sectionSecurityKey?: string,) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey);
            this.tenantId = identityService.current().tenantId;
        }

        activate(): void {
            super.activate();
        }

        onEdit() {
            this.context.setMode(Meevo.Model.MaintenanceFormState.Editing);
        }
        
        onSave() {
            this.context.setMode(Meevo.Model.MaintenanceFormState.Readonly);
            this.sendCss();
            this.saveFunction();
        }

        onCancel() {
            this.context.setMode(Meevo.Model.MaintenanceFormState.Readonly);
            this.cancelFunction();           
        }

        preSave(): void {
            this.sendCss()
            this.context.updateTextelSystemAutoReply();
            super.preSave();
        }
    }

}